<template>
  <div>
    <div class="road-map-section" v-if="roadMapArr">
      <div class="road-map-container">
        <div class="row">
          <div class="col-12" v-for="(card, index) in roadMapArr" :key="index">
            <div
              class="road-map-block"
              :class="index % 2 == 0 ? '' : 'left'"
              :data-aos="(index % 2 == 0 || mobileVersion) ? 'fade-left' : 'fade-right'"
            >
              <div class="road-map-block-card">
                <div class="road-map-block-card_img">
                  <img :src="card.StepIcon" alt="road map icon" />
                </div>
                <div class="road-map-block-card_text">
                  <h4 class="road-map-block-card_title">
                    {{ card.StepName }}
                  </h4>
                  <p v-html="card.StepBrief" class="road-map-block-card_subtitle">
                  </p>
                </div>
              </div>
              <div class="road-map-block-btn">
                <button class="custom-btn">{{ card.StepNumber }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AOS from 'aos';
import 'aos/dist/aos.css';
export default {
  data() {
        return {
            mobileVersion: false
        };
  },
  props: {
    roadMapArr: {
      type: Array,
    },
  },
  methods: {},
  mounted() {
    if (this.roadMapArr.length != 0) {
      setTimeout(function() {
          AOS.init();
      }, 100);
        if (window.innerWidth < 768) {
            this.mobileVersion = true;
        } else {
            this.mobileVersion = false;
        }
    }
  },
};
</script>
